import { CampaignTypes, ToneTypes } from '../../../../../../modals/push-notifications/campaign/Constants';

export default {
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Benachrichtigungstitel eingeben',
    },
    body: {
      label: 'Nachrichtentext',
      placeholder: 'Geben Sie Ihre Nachricht ein',
    },
    promo_code: {
      label: 'Promo-Code',
      placeholder: 'Promo-Code auswählen',
    },
    offers: {
      label: 'Angebote',
      placeholder: 'Angebot auswählen',
    },
    campaign_type: {
      label: 'Kampagnentyp',
      placeholder: 'Kampagnentyp wählen',
    },
    tone: {
      label: 'Tonalität',
      placeholder: 'Tonalität wählen',
    },
  },
  attachment: {
    heading: 'Was soll diese Kampagne bewerben?',
    offer: {
      title: 'Angebot',
      description: 'Aus aktiven Angeboten wählen.',
    },
    promo_code: {
      title: 'Promo-Code',
      description: 'Aus aktiven Promo-Codes wählen.',
    },
  },
  buttons: {
    generate: 'Generieren',
    improve: 'Verbessern mit AI',
    undo: 'Rückgängig machen ({{count}})',
  },
  no_promo_codes: {
    title: 'Keine geeigneten Promo-Codes',
    description: 'Erstellen Sie einen neuen Promo-Code.',
    create_promo_code: 'Promo-Code erstellen',
  },
  no_offers: {
    title: 'Keine aktiven Angebote',
    description: 'Erstellen Sie ein neues Angebot.',
    create_offer: 'Angebot erstellen',
  },
  tone_options: {
    [ToneTypes.Friendly]: 'Freundlich 🙂',
    [ToneTypes.Elegant]: 'Elegant ✨',
    [ToneTypes.Playful]: 'Verspielt 🎉',
    [ToneTypes.Professional]: 'Professionell 👨‍💼',
    [ToneTypes.Informative]: 'Informativ 📊',
    [ToneTypes.Persuasive]: 'Überzeugend 💪',
  },
  campaign_types: {
    [CampaignTypes.Promotional]: 'Promo 🚀',
    [CampaignTypes.Informational]: ' Informativ ℹ️',
  },
  feedback: {
    success: 'Erfolgreich erstellt',
    error: 'Fehler beim Erstellen',
  },
};
